/**
 * The three answers the shared IntelliCatch "Generate Tests" availability rule can give.
 * NotApplicable means the caller renders no button at all; Blocked means it renders one that is
 * disabled and shows `reason`.
 */
export enum IntelliCatchAvailabilityState {
  Available = 'available',
  Blocked = 'blocked',
  NotApplicable = 'notApplicable',
}

export interface IIntelliCatchAvailability {
  state: IntelliCatchAvailabilityState;
  reason: string;
}

/**
 * Blueprint field ids IntelliCatch fills on a generated Test, resolved from the Test item type's
 * OWN assigned fields. Empty string means the Test type has no such field.
 */
export interface IIntelliCatchTestFieldIds {
  stepsTableFieldId: string;
  assigneeFieldId: string;
  sourceFieldId: string;
}
